import React, { useCallback } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Button } from "react-bootstrap";
import { InputBox } from ".";
import { StockModal } from "./designer/StockModal";

interface Props {
  startingUrl: string,
  updatedFunction: (dataUrl: string) => void,
  aspectRatio: number;
  name: string;
  height?: number;
}

export const ImageEditor: React.FC<Props> = (props) => {
  const [currentUrl, setCurrentUrl] = React.useState("about:blank");
  const [dataUrl, setDataUrl] = React.useState(null);
  const [showStock, setShowStock] = React.useState(false);
  let timeout: any = null;

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    let files;
    if (e.target) files = e.target.files;
    const reader = new FileReader();
    reader.onload = () => {
      let url = reader.result.toString();
      setCurrentUrl(url);
      setDataUrl(url);
      setTimeout(selectDefaultCropZone, 500);
    };
    reader.readAsDataURL(files[0]);
  }

  const getHeaderButtons = () => (<div>
    <input data-testid="image-upload-input" type="file" onChange={handleUpload} id="fileUpload" accept="image/*" style={{ display: "none" }} />
    <Button data-testid="image-upload-button" size="sm" variant="info" style={{ float:"right", marginLeft:10 }} onClick={(e: React.MouseEvent) => { e.preventDefault(); document.getElementById("fileUpload").click(); }}>Upload</Button>
    <Button data-testid="stock-photos-button" size="sm" variant="outline-dark" style={{whiteSpace:"nowrap" }} onClick={(e: React.MouseEvent) => { e.preventDefault(); setShowStock(true); }}>Stock</Button>
  </div>)

  const cropper = React.useRef(null);

  const onCropperInit = (c: any) => {
    cropper.current = c;

    const el = document.querySelector("#cropperBox .content > div") as HTMLElement;

    const currentWidth = el.clientWidth
    const desiredHeight = currentWidth / 16 * 9;
    el.style.height = desiredHeight.toString() + "px";

    selectDefaultCropZone();
  }

  const selectDefaultCropZone = () => {
    let width = 1920;
    let height = 1080;

    if (width > 0) {
      //var imgData = cropper.getData();
      //var container = $('#imgContainer');
      var containerData = cropper.current.getContainerData();
      var imgAspect = cropper.current.getImageData().aspectRatio;
      var desiredAspect = (props.aspectRatio) ? props.aspectRatio : width / height;
      var scale = imgAspect / desiredAspect;
      console.log("Desired aspect", desiredAspect, "img aspect", imgAspect, "scale", scale);
      console.log("img aspect", imgAspect, "desired aspect", desiredAspect);
      if (scale < 1) {
        let l = (containerData.width - (containerData.width * scale)) / 2.0;
        let t = (containerData.height - (containerData.height * scale)) / 2.0;
        cropper.current.setCropBoxData({ width: containerData.width * scale, height: containerData.height * scale, left: l, top: t });
      } else if (scale === 1) {
        let cropWidth = containerData.height * desiredAspect;
        let l = (containerData.width - cropWidth) / 2.0;
        console.log("cropWidth", cropWidth, "l", l, "height", containerData.height, "aspect", desiredAspect);
        cropper.current.setCropBoxData({ width: cropWidth, left: l, height: containerData.height });
      } else {
        const cropHeight = containerData.width / width * height;
        const cropTop = ((props.height || 400) - cropHeight) / 2;
        cropper.current.setCropBoxData({ width: containerData.width, height: cropHeight, top: cropTop });
      }
    }


  }

  const cropCallback = () => {
    if (cropper.current !== null) {
      //const data = cropper.current.getCropBoxData();
      //const ratio = parseInt((300.0 / data.height).toString());
      //const width = data.width * ratio;
      let url = cropper.current.getCroppedCanvas({ maxWidth: 1920, maxHeight: 1920 }).toDataURL();
      setDataUrl(url);
    }
  }

  const handleCrop = () => {
    if (timeout !== null) {
      window.clearTimeout(timeout);
      timeout = null;
    }
    timeout = window.setTimeout(cropCallback, 200);
  }

  const handleStockSelected = (url: string) => {
    setCurrentUrl(url);
    setDataUrl(url);
    setTimeout(selectDefaultCropZone, 500);
    setShowStock(false);
  }

  const handleSave = () => { props.updatedFunction(dataUrl); }
  const handleCancel = () => { props.updatedFunction(null); }
  const init = useCallback(() => { setCurrentUrl(props.startingUrl) }, []); // eslint-disable-line

  React.useEffect(init, []); // eslint-disable-line

  //height: props.height || 400, 
  return (
    <InputBox id="cropperBox" headerIcon="" headerText="Crop" saveFunction={handleSave} saveText={"Update"} cancelFunction={handleCancel} headerActionContent={getHeaderButtons()}>
      <Cropper id="imageCropper"
        onInitialized={onCropperInit}
        src={currentUrl}
        style={{ width: "100%" }}
        aspectRatio={props.aspectRatio}
        guides={false}
        crop={handleCrop}
      />
      {showStock && <StockModal onClose={() => setShowStock(false)} onSelect={handleStockSelected}  />}
    </InputBox>
  );
}
